import axios from 'axios'
import { nrosUtil, $http} from './nros-util.js'

let util = Object.assign({}, nrosUtil)

//基于axios重新设置请求代理
let setHttpProxy = function(baseUrl) {
    let proxy = {};
    proxy.get = (url, config) => new Promise((resolve, reject) => {
        axios.get(baseUrl + url, config).then((data) => {
            resolve(data);
        }).catch((response) => {
            reject(response);
        })
    })

    proxy.post = (url, param, config) => new Promise((resolve, reject) => {
        axios.post(baseUrl + url, param, config).then((data) => {
            resolve(data)
        }).catch((response) => {
            reject(response);
        })
    })

    proxy.delete = (url, config) => new Promise((resolve, reject) => {
        axios.delete(baseUrl + url, config).then((data) => {
            resolve(data)
        }).catch((response) => {
            reject(response);
        })
    })

    proxy.put = (url, param, config) => new Promise((resolve, reject) => {
        axios.put(baseUrl + url, param, config).then((data) => {
            resolve(data)
        }).catch((response) => {
            reject(response);
        })
    })
    return proxy;
}

//获取当前请求服务代理
let getHttpClient = (productName) => {
    try {
        return setHttpProxy(util.nros.getPlugin('config').getConfig().products[productName].url);
    } catch (error) {
        throw new Error("请检查osConfig，是否正确配置了products属性，属性中是否存在" + productName + "产品的配置，以及url是否正确配置");
    }
};


util.compareEmitFlag = function(thisFlag, emitFlag) {
    if(emitFlag === thisFlag || (emitFlag === undefined && thisFlag === '')){
        return true;
    }
    return false;
}

//关于对象类型的深度拷贝
util.deepCopy = function(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Array) {
        return obj.map((e) => {
            if (typeof e === 'object') {
                return Object.assign({}, e)
            } else {
                return e
            }
        })
    }
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    if (obj instanceof Object) {
        var copy = {};
        for (var key in obj) { //递归
            if (obj.hasOwnProperty(key)) {
                copy[key] = this.deepCopy(obj[key]);
            }
        }
        return copy;
    }
}

//针对await有报错信息的处理，避免try catch影响性能,针对具有promise的方法函数
util.to = function(promise, errorExt) {
    return promise
        .then(function (data) { return [null, data]; })
        .catch(function (err) {
        if (errorExt) {
            Object.assign(err, errorExt);
        }
        return [err, undefined];
    });
}

export {
    util,
    $http,
    getHttpClient
}


// WEBPACK FOOTER //
// ./src/gms-util.js